/* src/js/tabComponent.js */

jQuery( document ).ready(function( $ ) {


    /*$('.js-tabTrigger').click(function () {
        $('.tabs__btn').removeClass('tabs__btn-active');
        $(this).addClass('tabs__btn-active');
    });*/




    $('.js-tabTrigger').click(function(){
        var tab_id = $(this).attr('data-tab');

        $('.js-tabTrigger').removeClass('tabs__btn-active');
        $('.tabs-content').removeClass('tabs-current');

        $(this).addClass('tabs__btn-active');
        $("#"+tab_id).addClass('tabs-current');
    });


});